<template>
  <div class="comment-form">
    <van-field
      ref="form"
      class="comment-input"
      v-model="message"
      type="textarea"
      :placeholder="$t('comment.add')"
      rows="1"
      maxlength="500"
      autosize
    />
    <div v-if="showAt" class="icon-at" @click="handleCallMention">@</div>
    <div :class="['btn', 'primary-bgcolor', !message.trim() && 'disabled']" @click="handleSubmit">发表</div>
    <van-popup
      class="contact-select-view"
      v-model="showContactSelect"
      position="bottom"
    >
      <contact-select
        v-if="showContactSelect"
        scenario="comment"
        @close-popup="toggleContactSelect"
        @add-contact="onAdd"
        @select-all="handleSelectAll"
      />
    </van-popup>
  </div>
</template>
<script>
import {i18n} from '@/utils/i18n'
import ajax from '@/utils/ajax'
import {COMMENTS_CREATE} from '@/config/api'
import ContactSelect from '../contact/ContactSelect'

export default {
  name: 'CommentForm',
  i18n,
  components: {
    ContactSelect
  },
  props: {
    disableAt: Boolean,
    replyData: Object,
    showAt: Boolean,
    isFetching: Boolean
  },
  data () {
    return {
      message: '',
      mentionInfo: {
        contacts: {},
        departments: {},
        groups: {}
      },
      disabledSubmit: false,
      showContactSelect: false,
      atIndex: -1
    }
  },
  watch: {
    $route (to, from) {
      this.showContactSelect = !!to.query.contactselect
    },
    replyData (val, oldVal) {
      if (val.index !== oldVal.index) {
        setTimeout(() => this.handleReply(val.item), 0)
      }
    },
    message (msg, oldMsg) {
      const msgLen = msg.length
      const oldMsgLen = oldMsg.length
      const reg = /[a-zA-Z]|[0-9]/

      if (this.showAt && (msgLen - oldMsgLen === 1)) { // 限定一次只输入一个字符 且为@ 调用选人控件
        for (let i = 0; i < msgLen; i++) {
          if (msg[i] !== oldMsg[i] && msg[i] === '@') {
            this.atIndex = i
            if (i === 0 || !reg.test(msg[i - 1])) {
              this.toggleQuery('contactselect')
            }
          }
        }
      }
    }
  },
  methods: {
    handleCallMention () {
      if (!this.disableAt) {
        this.atIndex = -1
        this.toggleQuery('contactselect')
      }
    },
    handleReply (item) {
      if (!this.mentionInfo.contacts[item.user.id]) {
        this.mentionInfo.contacts[item.user.id] = {
          name: item.user.name
        }
      }
      this.message = i18n.t('file.comment.reply') + '@' + item.user.name + ': '
    },
    encodeMentions (content) {
      const { contacts, groups, departments } = this.mentionInfo
      content += ' '
      for (let id in contacts) {
        content = content.replace(new RegExp('@(' + (contacts[id]['name'] /* + '|' + contacts[id]['email'] */).replace(/[().]/g, '\\$&') + ')(\\s|:|：)', 'g'), '@[' + id + ':' + contacts[id]['name'] + ']' + '$2')
      }

      // group and department don't have email
      for (let id in groups) {
        content = content.replace(new RegExp('@' + groups[id]['name'].replace(/[().]/g, '\\$&') + '(\\s|:)', 'g'), '@[g-' + id + ':' + groups[id]['name'] + ']' + '$1')
      }

      for (let id in departments) {
        content = content.replace(new RegExp('@' + departments[id]['name'].replace(/[().]/g, '\\$&') + '(\\s|:)', 'g'), '@[g-' + id + ':' + departments[id]['name'] + ']' + '$1')
      }

      const metion_all_string = i18n.t('file.comment.metionAllCollaborators')
      content = content.replace(new RegExp('@' + metion_all_string + '(\\s|:)', 'g'), '@[0:' + metion_all_string + ']' + '$1')
      return content.replace(/(\s*)$/, '')
    },
    handleSubmit (e) {
      if (this.isFetching || this.disabledSubmit) return
      const comment = this.message.trim().toString()
      if ((!comment || comment.toString().length === 0) || comment.toString().length > 500) {
        return false
      }

      this.disabledSubmit = true
      const content = this.encodeMentions(comment)
      const {typed_id} = this.$route.query

      ajax({
        url: COMMENTS_CREATE,
        data: {
          content,
          item_typed_id: typed_id
        },
        successMessage: i18n.t('file.comment.publishComplete')
      }).then(res => {
        this.disabledSubmit = false
        if (res && res.comment) {
          this.message = ''
          this.mentionInfo = {
            contacts: {},
            departments: {},
            groups: {}
          }
          this.$emit('add-comment', res.comment)
        }
      })
    },
    toggleContactSelect () {
      this.toggleQuery('contactselect')
    },
    completeMsg (str) {
      if (this.atIndex !== -1) {
        const strArr = this.message.split('')
        strArr.splice(this.atIndex, 1, str)
        this.message = strArr.join('')
      } else {
        this.message += str
      }
      this.$refs.form.$refs.input.focus()
    },
    onAdd (selectList, selectEntities) {
      let addStr = ''
      selectList.forEach(typeId => {
        const {id, name, is_department, is_group} = selectEntities[typeId]
        if (is_department) {
          this.mentionInfo.departments[id] = {
            name
          }
        } else if (is_group) {
          this.mentionInfo.groups[id] = {
            name
          }
        } else {
          this.mentionInfo.contacts[id] = {
            name
          }
        }

        addStr += `@${name} `
      })
      this.completeMsg(addStr)
    },
    handleSelectAll () {
      this.completeMsg(`@${i18n.t('file.comment.metionAllCollaborators')} `)
    }
  }
}
</script>
<style lang="postcss">
.comment-form {
  display: flex;
  align-items: center;
  border-top: 1px solid #dfdfdf;
  background-color: #fff;
  padding-right: 12px;

  &>* {
    flex: 0 0 auto
  }

  & .comment-input {
    flex: 1 1 auto;
    min-height: 48px;
    padding: 0;

    & .van-field__body {
      box-sizing: border-box;
      min-height: 36px;
      max-height: 108px;
      border-radius: 2px;
      margin: 6px 10px 7px 15px;
      padding: 6px 10px;
      border: 1px solid #dbdcdd;
    }
  }

  & textarea {
    line-height: 22px;
    max-height: 66px;
    font-size: 16px;
  }

  & .icon-at {
    font-size: 28px;
    line-height: 36px;
    color: #9198b2;
    margin-right: 10px;
  }

  & .btn {
    height: 36px;
    line-height: 36px;
    min-width: 48px;
    color: #fff;
    font-size: 16px;
  }
}
</style>
